import { render } from "./CarCreatePage.vue?vue&type=template&id=78943740"
import script from "./CarCreatePage.vue?vue&type=script&lang=js"
export * from "./CarCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__